<template>
  <section id="portfolio" class="section portfolio">

    <div class="container-fluid">
      <!-- Heading -->

      <div class="heading">
        <h2>Portfolio</h2>
        <p data-aos="fade-up">My Work</p>
      </div>
      <!-- Heading end-->
      <!-- Filter Menu -->
      <ul class="portfolio-menu mb-4">
        <li class="menu-item active" data-filter="all"> <span><i class="fa fa-archive me-1 ms-1"></i> All</span></li>
        <li  class="menu-item" data-filter="website"> <span ><i class="fa fa-globe me-1 ms-1"></i> Website</span></li>
        <li  class="menu-item" data-filter="mobile"> <span ><i class="fa fa-mobile me-1 ms-1"></i>Mobile</span></li>
        <li  class="menu-item" data-filter="desktop"> <span><i class="fa fa-desktop me-1 ms-1"></i>Desktop</span></li>
      </ul>
      <div class="container-fluid">
        <div  class=" list-projects">

          <VuePortfolioItem v-for="item in items" :item="item" :key="item" />
        </div>
      </div>


    </div>
  </section>
  <!-- Portfolio end -->
</template>

<script>
import VuePortfolioItem from "@/components/VuePortfolioItem";
import ProjectService from "@/services/ProjectService";
import $ from 'jquery';

export default {
  name: "PortfolioApp",
  components: {VuePortfolioItem},
  data() {
    return {
      data_type:"all",
      items: []
    }
  },
  async mounted() {
    this.items =  ProjectService.getAll();
    $(".menu-item").click(function(){
      const value=$(this).attr('data-filter');
      if(value=='all'){
        $('.project').show('2000');
      }else{
        $('.project').not("."+value).hide("1000");
        $('.project').filter("."+value).show("2000");
      }

      //add active
      $(this).addClass('active').siblings().removeClass('active')
    });
  },



}
</script>

<style scoped>
.portfolio{
  padding: 50px 0;
}
.portfolio-menu{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 0;
  padding: 0;
}
.menu-item{
  position: relative;
  width: content-box;
  list-style: none;
  margin: 0;
  padding: 5px 0;
  cursor: pointer;
  color: var(--font-color);
  font-size: 20px;
  font-weight: 500;
  transition: all 0.3s linear 0.01s;
}
.menu-item:before{
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  right: 0;
  bottom: -5px;
  background-color: transparent;
  transform-origin: center;
  transform: scale(0);
  transition: all 0.3s linear 0.01s;
}
.menu-item:hover,
.menu-item:focus,
.menu-item:active,
.menu-item.active{
  color: var(--primary-color);
  transition: all 0.3s linear 0.01s;
}
.menu-item:hover:before,
.menu-item.active:before{
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--primary-color);
  transform-origin: center;
  transform: scale(1);
  transition: all 0.3s linear 0.01s;
}
.list-projects{
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(300px,1fr));
  grid-auto-rows: 250px;
  grid-auto-flow: dense;
  grid-gap: 20px;
}
/*.list-projects .wide{
  grid-column: span 2;
}
.list-projects .tall{
  grid-row: span 2;
}
.list-projects .big{
  grid-row: span 2;
  grid-column: span 2;
}*/
@media (max-width: 512px) {
  .portfolio-menu{
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    padding: 0;
  }

  .menu-item{
    position: relative;
    width: content-box;
    list-style: none;
    margin: 0;
    padding: 3px 0;
    cursor: pointer;
    color: var(--font-color);
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s linear 0.01s;
  }
  .list-projects{
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(calc(100vw - 75px),1fr));
    grid-auto-rows: 250px;
    grid-auto-flow: dense;
    grid-gap: 20px;
  }
}
</style>